const state = {
  mainCard: '',
  viceCard: '',
  bindList: []
}

const mutations = {
  // SET_INFO(state, { mainCard, viceCard, bindList }) {
  //   state.mainCard = mainCard
  //   state.viceCard = viceCard
  //   state.bindList = bindList
  // }
  SET_LIST(state, bindList) {
    console.log(bindList)
    state.bindList = bindList
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
